import React from 'react'
import {
  FormSubentityTypeEnum,
  FormInterface,
} from 'src/shared/types/entities/form-interface'
import { SecondaryButton } from 'src/editor/shared/ui-lib/buttons'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { PaletteIcon } from 'src/editor/shared/icons/palette-icon'
import { useAppDispatch } from 'client/hooks/use-dispatch'
import { setSettingsEditing } from 'client/store/management/managementActions'

export const FormSubentityCommonSettingsButtonLink = ({
  formEntity,
  commonSettingsType,
}: {
  formEntity: FormInterface
  commonSettingsType: FormSubentityTypeEnum
}) => {
  const { t } = useTypedTranslation()

  const dispatch = useAppDispatch()

  return (
    <SecondaryButton
      className="w-full"
      iconBefore={<PaletteIcon />}
      onClick={() =>
        dispatch(
          setSettingsEditing({
            id: formEntity.id,
            type: formEntity.type,
            subentityId: undefined,
            commonSettingsType,
          }),
        )
      }
    >
      {t('entity_settings.form.link_to_common_settings')}
    </SecondaryButton>
  )
}
